import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import LoginTextField from '../../../fields/normal/LoginTextField';
import styles from './style';

const validate = values => {
  const errors = {};
  const requiredFields = ['email', 'password'];
  requiredFields.forEach(field => {
    if (!values[field]) {
      errors[field] = 'Required';
    }
  });
  if (
    values.email &&
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
  ) {
    errors.email = 'Invalid email address';
  }
  return errors;
};

const renderTextField = ({
  label,
  labelTouched,
  labelUntouched,
  FormHelperText,
  input,
  meta: { touched, invalid, error, dirty, active },
  ...custom
}) => (
  <LoginTextField
    // label={active ? 'active' : 'notactive'}
    label={
      label || (labelTouched && dirty) || active || touched
        ? labelTouched
        : labelUntouched || 'generic label'
    }
    // label={error}
    placeholder={label}
    error={touched && invalid}
    helperText={touched && error}
    {...input}
    {...custom}
  />
);

const ForgotPwForm = props => {
  const {
    handleSubmit,
    handleBackToNormalForm,
    submitting,
    classes,
    invalid,
    isLoginLoading,
    submitFailed,
    error,
  } = props;
  return (
    <>
      <Typography variant="body1">
        Forgot your password? No worries please enter your email, and we will
        send you a code to reset.
      </Typography>
      <form onSubmit={handleSubmit}>
        <div className={classes.fieldContain}>
          <Field
            name="email"
            component={renderTextField}
            labelUntouched={
              <Typography variant="h6" className={classes.placeText}>
                enter email address
              </Typography>
            }
            labelTouched={
              <Typography variant="h6" className={classes.placeText}>
                email address
              </Typography>
            }
          />
        </div>
        {submitFailed && error && (
          <Typography
            className={classes.formErrorMsg}
            variant="body2"
            color="error"
          >
            {error}
          </Typography>
        )}
        <div className={classes.buttonContain}>
          <div className={classes.buttonContain_back}>
            <Button
              className={classes.mainButton}
              onClick={handleBackToNormalForm}
              // variant="outlined"
              // color="secondary"
              variant="contained"
              color="primary"
            >
              Back
            </Button>
          </div>
          <div className={classes.buttonContain_submit}>
            <Button
              className={classes.mainButton}
              type="submit"
              disabled={submitting || invalid || isLoginLoading}
              variant="contained"
              color="primary"
            >
              Submit
              {isLoginLoading && (
                <CircularProgress
                  size={34}
                  className={classes.buttonProgress}
                />
              )}
            </Button>
          </div>
        </div>
      </form>
    </>
  );
};

renderTextField.propTypes = {
  label: PropTypes.string,
  labelTouched: PropTypes.any,
  labelUntouched: PropTypes.any,
  FormHelperText: PropTypes.any,
  input: PropTypes.any,
  meta: {
    touched: PropTypes.any,
    invalid: PropTypes.any,
    error: PropTypes.any,
    dirty: PropTypes.any,
    active: PropTypes.any,
  },
};

ForgotPwForm.propTypes = {
  handleSubmit: PropTypes.func,
  handleBackToNormalForm: PropTypes.func,
  submitting: PropTypes.any,
  classes: PropTypes.object,
  invalid: PropTypes.any,
  isLoginLoading: PropTypes.bool,
  submitFailed: PropTypes.any,
  error: PropTypes.any,
};

export default withStyles(styles)(
  reduxForm({
    form: 'ForgotPwForm',
    validate,
  })(ForgotPwForm),
);
